const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
];

export function fmtDate(d: Date | undefined): string {
  if (!d || Number.isNaN(d.getTime())) return "—";
  return `${d.getDate()} ${MONTHS[d.getMonth()]} ${d.getFullYear()}`;
}

export function fmtShortDate(d: Date | undefined): string {
  if (!d || Number.isNaN(d.getTime())) return "—";
  return `${d.getDate()} ${MONTHS[d.getMonth()]}`;
}

export function shiftLabel(shift: string): string {
  if (!shift || shift === "all") return "All shifts";
  if (shift === "day") return "Day shift";
  if (shift === "night") return "Night shift";
  return shift;
}
